import { render, staticRenderFns } from "./RegionMaster.vue?vue&type=template&id=f0c6a0d8&"
import script from "./RegionMaster.vue?vue&type=script&lang=js&"
export * from "./RegionMaster.vue?vue&type=script&lang=js&"
import style0 from "./RegionMaster.vue?vue&type=style&index=0&id=f0c6a0d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports